import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useStore, extractErrorMessage } from "../../../helpers";

interface CreateNotebookPayload {
  name: string;
  tags?: string[];
  more?: Record<string, unknown>;
}

export const useCreateNotebook = () => {
  const rootStore = useStore();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateNotebookPayload) => {
      const res = await rootStore.apiRequestHandler(
        "tars/notebooks",
        payload,
        "Failed to create notebook"
      );
      return res;
    },
    onSuccess: () => {
      toast.success("Notebook created successfully");
      queryClient.invalidateQueries({ queryKey: ["notebooks"] });
    },
    onError: (error: unknown) => {
      toast.error(extractErrorMessage(error, "Failed to create notebook"));
    },
  });
};
